module.exports = __webpack_public_path__ + "img/blue_lock.deb478b1.png";